<template>
  <main class="content">
    <loading :isLoading="loaded" />
    <div class="container-fluid p-0">
      <div class="row">
        <div class="col-9 d-none d-sm-block">
          <h3><b-icon icon="list" aria-hidden="true"></b-icon> Product List</h3>
        </div>
        <div class="col-3 d-none d-sm-block">
          <b-button variant="primary" class="mb-2" @click="onAdd()">
            Add New
          </b-button>
        </div>
      </div>
      <hr />
      <div class="col-12 col-xl-12">
        <b-container fluid class="my-1">
          <b-row>
            <b-col class="my-1">
              <b-form-group
                label="Filter"
                label-for="filter-input"
                class="mb-0"
              >
                <b-input-group size="sm">
                  <b-form-input
                    id="filter-input"
                    v-model="filter"
                    type="search"
                    placeholder="Type to Search"
                  ></b-form-input>

                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''"
                      >Clear</b-button
                    >
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col class="my-1">
              <b-form-group
                label="Per page"
                label-for="per-page-select"
                class="mb-0"
              >
                <b-form-select
                  id="per-page-select"
                  v-model="perPage"
                  :options="pageOptions"
                  size="sm"
                ></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <!-- Main table element -->
          <b-table
            :items="products"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :filter-included-fields="filterOn"
            show-empty
            @filtered="onFiltered"
            :striped="true"
            :bordered="true"
            :borderless="true"
            :outlined="true"
            :hover="true"
            :fixed="true"
            :busy="isBusy"
          >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </template>
            <template #cell(avatar)="row">
              <img :src="row.value" alt="" width="80" height="80" />
            </template>
            <template #cell(categories)="row">
              <div v-for="(category, index) in row.value" :key="index">
                <b-badge variant="info"> {{ category.name }}</b-badge>
              </div>
            </template>
            <template #cell(shop)="row">
              <div v-for="(shop, index) in listShop" :key="index">
                <b-badge v-if="row.item.shop_id === shop.id" variant="info"> {{ shop.name }}</b-badge>
              </div>
            </template>
            <template #cell(name)="row">
              {{ row.value }}
            </template>
            <template #cell(is_public)="row">
              <b-badge variant="danger" v-if="!row.value">Unpublic</b-badge>
              <b-badge variant="success" v-else>Public</b-badge>
            </template>
            <template #cell(regular_price)="row">
              <div>{{ getPrice(row.item.regular_price )}}</div>
            </template>

            <template #cell(actions)="row">
              <b-button size="sm" class="mb-2" @click="onEdit(row.item.id)">
                <b-icon icon="pencil-square" aria-hidden="true"></b-icon>
              </b-button>
              <b-button
                size="sm"
                variant="danger"
                class="mb-2"
                @click="onDelete(row.item)"
              >
                <b-icon icon="trash" aria-hidden="true"></b-icon>
              </b-button>
            </template>
          </b-table>
          <b-col sm="4" md="4" class="my-1">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="fill"
              first-text="First"
              prev-text="Prev"
              next-text="Next"
              last-text="Last"
            ></b-pagination>
          </b-col>
        </b-container>
      </div>
    </div>
  </main>
</template>

<script>
import { mapState } from "vuex"

export default {
  data() {
    return {
      isBusy: true,
      fields: [
        {
          key: "avatar",
          label: "Avatar"
        },
        {
          key: "name",
          label: "Name"
        },
        {
          key: "categories",
          label: "Categories"
        },
        {
          key: "shop",
          label: "Shop"
        },
        {
          key: "regular_price",
          label: "Price"
        },
        {
          key: "is_public",
          label: "Status"
        },
        { key: "actions", label: "Actions" }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15, 20],
      filter: null,
      filterOn: [],
      loaded: false
    }
  },
  computed: {
    ...mapState({
      products: (state) => state.product.products,
      listShop: (state) => state.user.listShop
    })
  },
  async mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      await this.$store.dispatch("product/get")
      this.totalRows = this.products.length
      this.isBusy = false
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    async onDelete(product) {
      await this.$bvModal
        .msgBoxConfirm("Do you want to delete this product?", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Delete",
          cancelTitle: "Cancel",
          hideBackdrop: true,
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then((value) => {
          if (value) this.deleteProduct(product.id)
        })
        .catch(() => {
          // An error occurred
        })
    },
    async deleteProduct(id) {
      this.loaded = true
      await this.$store.dispatch("product/delete", id)
      this.loaded = false
    },
    onAdd() {
      this.$router.push("/product/add")
    },
    onEdit(id) {
      this.$router.push("/product/edit/" + id)
    },
    getPrice(price) {
      return price ? price.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,") : null
    },
  }
}
</script>